/**
 * Color bands for the two headline numbers that aren't already a Warcraft
 * Logs percentile (which has its own official palette in `parses.ts`) —
 * Mythic+ score and item level. Raider.IO colors its own score the same
 * way: a quick "how good is this, roughly" cue rather than a precise
 * measurement. There's no canonical source for exact thresholds (Raider.IO
 * itself rescales them by season, and Blizzard doesn't publish ilvl bands
 * at all), so these are reasonable round numbers for the current
 * expansion's endgame range — nudge them next season rather than treat
 * them as exact.
 */
const GREY = '#6b7280';
const GREEN = '#1eff00';
const BLUE = '#0070dd';
const PURPLE = '#a335ee';
const ORANGE = '#ff8000';
const PINK = '#e268a8';
const GOLD = '#ffd700';
/** Mythic+ score, roughly matching Raider.IO's own color bands for a current-tier score. */
export function mythicPlusScoreColor(score) {
    if (score === null)
        return GREY;
    if (score >= 3400)
        return PINK;
    if (score >= 2800)
        return ORANGE;
    if (score >= 2200)
        return PURPLE;
    if (score >= 1500)
        return BLUE;
    if (score >= 500)
        return GREEN;
    return GREY;
}
/** Equipped item level, banded the same way — undergeared grey up through current-tier BiS pink. */
export function itemLevelColor(itemLevel) {
    if (itemLevel === null)
        return GREY;
    if (itemLevel >= 370)
        return PINK;
    if (itemLevel >= 350)
        return ORANGE;
    if (itemLevel >= 330)
        return PURPLE;
    if (itemLevel >= 310)
        return BLUE;
    if (itemLevel >= 280)
        return GREEN;
    return GREY;
}
/**
 * The same five-color ladder as above, but for stats with no fixed "good"
 * number — only standing relative to whoever else is currently being shown
 * (e.g. how many 10+ keys each character in the roster has timed this
 * season: there's no universal threshold for that, only "more than
 * so-and-so, less than someone else"). Lowest rank green, highest "shiny gold".
 */
export const RELATIVE_RANK_COLORS = [GREEN, BLUE, PURPLE, ORANGE, GOLD];
/** Which of the `RELATIVE_RANK_COLORS` a 0-indexed rank falls into, out of `total` distinct values being compared. */
export function relativeRankTier(rank, total) {
    if (total <= 0)
        return 0;
    return Math.min(RELATIVE_RANK_COLORS.length - 1, Math.floor((rank / total) * RELATIVE_RANK_COLORS.length));
}
//# sourceMappingURL=scoreColors.js.map